
import { request, EMethods } from './ApiService'

import config from '../config'

const getResult = async () => {

    const url = config.apiHost + '/notifications'

    const response = await request(EMethods.get, 'NOTIFICATIONS_LOAD_RESULT', url)

    return response.data
}

const setRead = async (notification_id: string) => {

    const url = `${config.apiHost}/notifications/${notification_id}/set-read`

    const res = await request(EMethods.put, 'NOTIFICATION_SET_READ', url)

    return res.data
}

const saveFCMToken = async (token: string) => {

    const url = `${config.apiHost}/notifications/save-fcm-token`

    const res = await request(EMethods.post, 'NOTIFICATION_SAVE_FCM_TOKEN', url, { token })

    return res.data
}

const getNotification = async (notification_id: string) => {

    const url = `${config.apiHost}/notifications/${notification_id}`

    const res = await request(EMethods.get, 'NOTIFICATION_GET_NOTIFICATION', url)

    return res.data
}

export default {
    getNotification,
    getResult,
    setRead,
    saveFCMToken,
}
